import React, { useState } from "react";
import { authHeader, handleResponse } from '_helpers';
import { authenticationService } from '_services';



 
const FullImage = (props) => {
    const fileID = (props.match.params.fileID !== undefined) ? props.match.params.fileID : null;

    const [img, setImg] = useState("");

    const currentUser = authenticationService.currentUserValue;

    React.useEffect(() => {
            if (!currentUser) {
                window.location.assign('/login');
            }

            fetch('/api/v1/tele/upload/' + fileID, {
                    method: 'GET',
                    headers: authHeader()
            })
                .then(handleResponse)
                .then(
                    (result) => {
                        setImg("data:" + result.data.FileType + ";base64, "+result.data.fileData)
                    },
                    (error) => {
                        alert(error);
                    }
                );
        }, []);





  return (
      <>
          <img
              src={img}
          />
    </>
  );
}

export default FullImage;
